import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Http } from '@angular/http';
import { ModalController } from 'ionic-angular';
import {HomePage} from '../home/home';
import {AguardandoPage} from '../aguardando/aguardando';
import {AceitoPage} from '../aceito/aceito';


/**
 * Generated class for the AcompanharPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-acompanhar',
  templateUrl: 'acompanhar.html',
})
export class AcompanharPage {

  constructor(
  	public navCtrl: NavController,
     public navParams: NavParams,
     public loadingCtrl: LoadingController,
    public _http: Http,
    public modalCtrl : ModalController) {
  }

  ionViewDidLoad() {
  }
  pageaguardando(){
    this.navCtrl.push(AguardandoPage);
  } 
   pageaceito(){
    this.navCtrl.push(AceitoPage);
  }
  logout(){
    localStorage.clear();
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/acompanhar/acompanhar.ts